// extracted by mini-css-extract-plugin
var _1 = "textarea-module_errorBorder_XFFMJ";
var _2 = "textarea-module_errorTextElement_OOLDZ";
var _3 = "textarea-module_textareaElement_sxNaC";
var _4 = "textarea-module_textareaLabelElement_i_0E1";
var _5 = "textarea-module_textareaWrapper_Tayiw";
export { _1 as "errorBorder", _2 as "errorTextElement", _3 as "textareaElement", _4 as "textareaLabelElement", _5 as "textareaWrapper" }
